var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container home"},[(_vm.columnId > 0)?_c('List',{on:{"resetShare":_vm.resetShareHandle}}):_c('ImgList',{on:{"resetShare":_vm.resetShareHandle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }